
/**
 * This is an adjustment model
 */
class Adjustment {
    /**
     * @param {string} label
     * @param {number} percent
     * @param {number} dollar
     */
    constructor(label='Adjustments', percent=0.0, dollar=0.0) {
        this.label = label
        this.percent = percent
        this.dollar = dollar
    }
}

module.exports = {
    Adjustment,
}
